import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionDailySchedule = () => {
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const today = new Date().toISOString().split('T')[0]; // Get current date in 'YYYY-MM-DD' format
    const [date, setDate] = useState(today);
    const [dailyScheduleList, setDailyScheduleList] = useState([]);
    const [scheduleChecked, setScheduleChecked] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [teacherNameSort, setTeacherNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "teacherMasterDetails.teacherName",
        "teacherMasterDetails.subjectName",
        "teacherMasterDetails.gradeName",
        "teacherMasterDetails.divisionName",
        "dailyTeachingDetails.SyllabusStructureMaster.syllabusStructureName",
        "dailyTeachingDetails.LessonMaster.lessonName",
        "dailyTeachingDetails.TopicMaster.topicName",
        "dailyTeachingDetails.SubTopicMaster.subTopicName",
        "dailyTeachingDetails.InstituteSyllabusStructureMaster.instituteSyllabusStructureName",
        "dailyTeachingDetails.InstituteLessonMaster.instituteLessonName",
        "dailyTeachingDetails.InstituteTopicMaster.instituteTopicName",
        "dailyTeachingDetails.InstituteSubTopicMaster.instituteSubTopicName",
        "dailyTeachingDetails.SectionSyllabusStructureMaster.sectionSyllabusStructureName",
        "dailyTeachingDetails.SectionLessonMaster.sectionLessonName",
        "dailyTeachingDetails.SectionTopicMaster.sectionTopicName",
        "dailyTeachingDetails.SectionSubTopicMaster.sectionSubTopicName",
        "comment"
    ];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getDailyScheduleList();
    }, [date]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getDailyScheduleList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (date !== "") {
                setDailyScheduleList(await searchArray("C", `/conflict-schedule?date=${date}&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(dailyScheduleList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(dailyScheduleList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > dailyScheduleList.length) {
            endIndex = dailyScheduleList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(dailyScheduleList.slice(startIndex, endIndex));
    }, [dailyScheduleList, currPage, itemsPerPage]);

    const getDailyScheduleList = async () => {
        let apiUrl = `/conflict-schedule?date=${date}&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        apiUrl = apiUrl.replace(/&$/, '');
        try {
            const response = await authorizedAxiosCommon.get(apiUrl);
            setDailyScheduleList(response.data.data);
        } catch (error) {
            setDailyScheduleList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e) => {
        setDate(e.target.value);
    }

    const handleInputScheduleData = (dailyScheduleId, e) => {
        const { name, value } = e.target;
        const index = scheduleChecked.findIndex(item => item.dailyScheduleId === dailyScheduleId);
        const updatedPresentChecked = index !== -1
            ? [
                ...scheduleChecked.slice(0, index),
                {
                    ...scheduleChecked[index],
                    [name]: value
                },
                ...scheduleChecked.slice(index + 1)
            ]
            : [...scheduleChecked, { dailyScheduleId: dailyScheduleId, [name]: value }];

        setScheduleChecked(updatedPresentChecked);
    };

    const getTeachingDetailsDiv = (subjectName, gradeName, divisionName, syllabusStructureName, lessonName, topicName, subTopicName) => {
        return (
            <>
                <td>
                    <div>
                        Subject &rarr; {subjectName}
                    </div>
                    <div>
                        Class &rarr; {gradeName}
                    </div>
                    <div>
                        Division &rarr; {divisionName}
                    </div>
                </td>
                <td>
                    <div>
                        Syllabus Structure &rarr; {syllabusStructureName}
                    </div>
                    <div>
                        Lesson &rarr; {lessonName}
                    </div>
                    <div>
                        Topic &rarr; {topicName}
                    </div>
                    <div>
                        Subtopic &rarr; {subTopicName}
                    </div>
                </td>
            </>
        )
    }

    const GetMappedData = ({ dailyTeachingDetails, teacherMasterDetails }) => {
        const subjectName = teacherMasterDetails.subjectName;
        const gradeName = teacherMasterDetails.gradeName;
        const divisionName = teacherMasterDetails.divisionName;

        if (dailyTeachingDetails.type === "A") {
            const syllabusStructureName = dailyTeachingDetails.SyllabusStructureMaster.syllabusStructureName;
            const lessonName = dailyTeachingDetails.LessonMaster.lessonName;
            const topicName = dailyTeachingDetails.TopicMaster.topicName;
            const subTopicName = dailyTeachingDetails.SubTopicMaster.subTopicName;

            return (
                getTeachingDetailsDiv(subjectName, gradeName, divisionName, syllabusStructureName, lessonName, topicName, subTopicName)
            )
        } else if (dailyTeachingDetails.type === "I") {
            const syllabusStructureName = dailyTeachingDetails.InstituteSyllabusStructureMaster.instituteSyllabusStructureName;
            const lessonName = dailyTeachingDetails.InstituteLessonMaster.instituteLessonName;
            const topicName = dailyTeachingDetails.InstituteTopicMaster.instituteTopicName;
            const subTopicName = dailyTeachingDetails.InstituteSubTopicMaster.instituteSubTopicName;

            return (
                getTeachingDetailsDiv(subjectName, gradeName, divisionName, syllabusStructureName, lessonName, topicName, subTopicName)
            )
        } else {
            const syllabusStructureName = dailyTeachingDetails.SectionSyllabusStructureMaster.sectionSyllabusStructureName;
            const lessonName = dailyTeachingDetails.SectionLessonMaster.sectionLessonName;
            const topicName = dailyTeachingDetails.SectionTopicMaster.sectionTopicName;
            const subTopicName = dailyTeachingDetails.SectionSubTopicMaster.sectionSubTopicName;

            return (
                getTeachingDetailsDiv(subjectName, gradeName, divisionName, syllabusStructureName, lessonName, topicName, subTopicName)
            )
        }
    }

    const updateDailySchedule = async () => {
        try {
            setLoading(true);
            let apiUrl = `/update-schedule`;
            const response = await authorizedAxiosCommon.post(apiUrl, scheduleChecked);
            await getDailyScheduleList();
            setTeacherNameSort(null);

            Swal.fire({
                text: response.data.message
            })
        } catch (error) {
            setDailyScheduleList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setDate("");
        setDailyScheduleList([]);
        setScheduleChecked([]);
        setTeacherNameSort(null);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Daily Schedule</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-tasks"></i>Daily Schedule</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="date" className="col-form-label">Select Date :</label>
                                                    <input type="date" className="form-control" id="date" name='date' onChange={handleInputChange} value={date} max={today} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={updateDailySchedule}>Save</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id="teacherCredentitals">
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Teacher Name
                                                                                <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setDailyScheduleList} setCurrPage={setCurrPage} sortingPath={"teacherMasterDetails.teacherName"} />
                                                                            </th>
                                                                            <th scope="col">Teacher Data</th>
                                                                            <th scope="col">Teaching Data</th>
                                                                            <th scope='col'>Remark</th>
                                                                            <th scope='col' style={{ width: "20%" }} >Message</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {displayedData.length > 0 ?
                                                                            displayedData.map((teacher, index) => (
                                                                                <tr>
                                                                                    <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                    <td>{teacher.teacherMasterDetails.teacherName}</td>
                                                                                    <GetMappedData dailyTeachingDetails={teacher.dailyTeachingDetails} teacherMasterDetails={teacher.teacherMasterDetails} />
                                                                                    <td>
                                                                                        <select class="form-select" aria-label="Default select example"
                                                                                            value={
                                                                                                scheduleChecked.some(data => data.dailyScheduleId === teacher.dailyScheduleId)
                                                                                                    ? scheduleChecked.find(data => data.dailyScheduleId === teacher.dailyScheduleId).flag
                                                                                                    : teacher?.flag || ""
                                                                                            }
                                                                                            name='flag'
                                                                                            onChange={(e) => { handleInputScheduleData(teacher.dailyScheduleId, e) }}
                                                                                        >
                                                                                            <option selected value={''} disabled>Select Schedule</option>
                                                                                            <option value={1}>Complete</option>
                                                                                            <option value={2}>InComplete</option>
                                                                                            <option value={3}>Partially Complete</option>
                                                                                        </select>
                                                                                    </td>
                                                                                    <td>
                                                                                        <textarea className="form-control" id="comment" name="comment" rows={3}
                                                                                            value={
                                                                                                scheduleChecked.some(data => data.dailyScheduleId === teacher.dailyScheduleId)
                                                                                                    ? scheduleChecked.find(data => data.dailyScheduleId === teacher.dailyScheduleId).comment
                                                                                                    : teacher?.comment || ""
                                                                                            }
                                                                                            onChange={(e) => handleInputScheduleData(teacher.dailyScheduleId, e)}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Conflict List Available</th>
                                                                            </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={dailyScheduleList.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionDailySchedule;